import { useContext } from 'react';
import ModalContext from './ModalContext';

const useModalId = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useModalId must be used within a ModalContextProvider');
  }

  return context.modalId;
};

export default useModalId;
